import Vue from 'vue'
import App from './App.vue'
import VueSocketIOExt from 'vue-socket.io-extended';
import { io } from 'socket.io-client';

//const socket = io('http://localhost:3000', {autoConnect: false});
const socket = io('http://cachosws.mattkingz.cl', {autoConnect: false});

Vue.use(VueSocketIOExt, socket);

Vue.config.productionTip = false

new Vue({
  render: function (h) { return h(App) },
}).$mount('#app')
